import { useNavigate } from 'react-router-dom';
import { LOCALES, useI18n, type Locale } from '../i18n';

const LABELS: Record<Locale, string> = {
  [LOCALES.ENGLISH]: 'EN',
  [LOCALES.SPANISH]: 'ES',
  [LOCALES.FRENCH]:  'FR',
};

interface Props {
  lang: Locale;
}

export default function LangSwitcher({ lang }: Props) {
  const { setLocale } = useI18n();
  const navigate = useNavigate();

  const handleChange = (next: Locale) => {
    if (next === lang) return;
    setLocale(next);
    // Swap the lang prefix in the current URL so the page reloads in the new locale.
    const parts = window.location.pathname.split('/').filter(Boolean);
    parts[0] = next;
    navigate('/' + parts.join('/'));
  };

  return (
    <div className="lang-switcher" role="group" aria-label="language">
      {Object.values(LOCALES).map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => handleChange(l)}
          className={l === lang ? 'lang-btn lang-btn-active' : 'lang-btn'}
          aria-pressed={l === lang}
        >
          {LABELS[l]}
        </button>
      ))}
      <style>{css}</style>
    </div>
  );
}

const css = `
.lang-switcher { display: inline-flex; border: 1px solid var(--c-border); border-radius: var(--radius-sm); overflow: hidden; }
.lang-btn { border: none; border-radius: 0; padding: 4px 10px; font-size: 0.8rem; font-weight: 500; }
.lang-btn + .lang-btn { border-left: 1px solid var(--c-border); }
.lang-btn-active { background: var(--c-accent); color: var(--c-accent-fg); }
.lang-btn-active:hover { background: var(--c-accent); }
`;
